// Use the existing Shopify Inbox web component; do not create another chat.
// Shopify's public theme integration uses the chat's boolean `open` attribute.
async function waitForChat() {
  const deadline = Date.now() + 8000;
  do {
    const chat = document.querySelector('shopify-chat');
    if (chat && customElements.get('shopify-chat')) return chat;
    await new Promise((resolve) => window.setTimeout(resolve, 200));
  } while (Date.now() < deadline);
  return null;
}

document.addEventListener('click', async (event) => {
  const trigger = event.target instanceof Element && event.target.closest('[data-momo-chat-open]');
  if (!trigger || trigger.disabled) return;
  trigger.disabled = true;
  trigger.setAttribute('aria-busy', 'true');
  try {
    const chat = await waitForChat();
    if (chat) {
      // Opening is idempotent: a repeated click must never close an open chat.
      chat.setAttribute('open', '');
    } else if (trigger.dataset.chatFallback) {
      window.location.assign(trigger.dataset.chatFallback);
    }
  } finally {
    trigger.disabled = false;
    trigger.removeAttribute('aria-busy');
  }
});
